// extracted by mini-css-extract-plugin
export default {"btn":"SwitchInput_btn__ObkkF"};